function r(c, n = [], o) {
  const e = {};
  return n.forEach((t) => {
    e[t] = c[t];
  }), Object.assign(e, o);
}
export {
  r as keep
};



//////////////////
// WEBPACK FOOTER
// ./~/@oppein/op-web-components/dist/es/~/.pnpm/naive-ui@2.42.0_vue@3.5.18/~/naive-ui/es/_utils/vue/keep.js
// module id = 200
// module chunks = 41